import React, { useState } from 'react';

import './CookieConsent.scss';

const DISMISSED_KEY = 'cookie_notice_dismissed';

const CookieConsent = () => {
  const [visible, setVisible] = useState(() => {
    try {
      return !window.localStorage.getItem(DISMISSED_KEY);
    } catch {
      return true;
    }
  });

  if (!visible) return null;

  const handleDismiss = () => {
    try {
      window.localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // silent
    }
    setVisible(false);
  };

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__inner">
        <div className="cookie-consent__text">
          <div className="cookie-consent__icon">
            <i className="fas fa-cookie-bite" />
          </div>
          <div>
            <p className="cookie-consent__title">Cookies &amp; Analytics</p>
            <p className="cookie-consent__desc">
              We use cookies for authentication and collect usage analytics
              (page views, searches, interactions) to improve the platform.
              By continuing to use PlaySportUSA you agree to our data practices.
            </p>
          </div>
        </div>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--accept"
            onClick={handleDismiss}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
